import { Rerequisition, Requisition } from '@customTypes/requisition';
import axios from '@hooks/useAxios';

export * from './draftOrderActions';

const requisitionBaseUrl = '/requisition';

export const fetchRequisitions = async (): Promise<Requisition[]> => {
  return axios.get(requisitionBaseUrl, { params: { per_page: '500' } }).then(res => res.data.results);
};

export const fetchRequisitionById = async (requisitionId: string): Promise<Requisition> => {
  return axios.get(`${requisitionBaseUrl}/${requisitionId}`).then(res => res.data);
};

// TODO: replace the unknown with an actual type.
export const placeOrder = async (payload: unknown) => {
  return axios.post(requisitionBaseUrl, payload);
};

export const fetchRerequisition = async (requisitionId: string): Promise<Rerequisition> => {
  return axios.get(`${requisitionBaseUrl}/${requisitionId}/rerequisition/`).then(res => res.data);
};
